import { ALL_LANGUAGES, DEFAULT_LANG } from "../../constants";
import markdownPagePaths from "../markdownPagePaths.json";

const homePagePaths = Object.fromEntries(
  ALL_LANGUAGES.map((lang) => [
    lang,
    lang === DEFAULT_LANG ? "/" : `/${lang}/`,
  ]),
);

const allPagePaths = {
  ...markdownPagePaths,
  home: homePagePaths,
};

const allPageNames = Object.keys(allPagePaths);

export const getPageLangVariantsForPagePath = (pagePath) => {
  const pageName = allPageNames.find(
    (name) => Object.values(allPagePaths[name]).includes(pagePath),
    // eslint-disable-next-line function-paren-newline
  );

  if (!pageName) {
    return null;
  }

  const pagePaths = allPagePaths[pageName];

  const pageLangVariants = Object.entries(pagePaths).map(
    ([lang, publicPath]) => ({
      lang,
      isDefault: lang === DEFAULT_LANG,
      publicPath,
    }),
  );

  return pageLangVariants;
};
